import routPath from "../../../Routes/NameSpace";

export const PcMenuConfig = [
    {
        id: 1,
        title: "صفحه نخست",
        url: routPath.default,
        sectionName: "banner"
    },
    {
        id: 2,
        title: "سرمایه‌گذاری‌ها",
        url: routPath.investments,
        sectionName: ""
    },
    {
        id: 3,
        title: "اخبار",
        url: routPath.news,
        sectionName: ""
    },
    {
        id: 4,
        title: "درباره ما",
        url: routPath.aboutUs,
        sectionName: ""
    },
    {
        id: 5,
        title: "سوالات متداول",
        url: routPath.FAQ,
        sectionName: ""
    },
    {
        id: 6,
        title: "ارتباط با ما",
        url: routPath.contactUs,
        sectionName: ""
    },
    {
        id: 6,
        title: "اطلاعیه",
        url: routPath.notifications,
        sectionName: ""
    },
]